import React, { PureComponent } from "react";
import { states } from "../../../reducers/queriesStates";
import L from "leaflet";
import { Polyline } from "react-leaflet";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import WinterMaintenceSensorRoutePoupup from "./WinterMaintenceSensorRoutePoupup";

class WinterMaintenceMapUnitRouteLayer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dataPoupup: null,
      positionPoupup: null,
    };
  }

  componentDidUpdate(prevProps) {
    const { winterCompaniesRoutesDataState } = this.props;

    if (winterCompaniesRoutesDataState === states.REQUEST && prevProps.winterCompaniesRoutesDataState !== states.REQUEST) {
      this.setState({ dataPoupup: null, positionPoupup: null });
    }
  }

  setPoupupLayers(data) {
    const { onSetWinterPoupup } = this.props;

    const unitLayersWithin = {};

    data.layersWithin.forEach((x) => {
      if (x.layer.options.unit !== undefined) {
        if (unitLayersWithin[x.layer.options.unit.id] === undefined) {
          const points = [];

          x.layer.options.unit.dataRoute.data.forEach((pointData) => {
            const latlng = [parseFloat(pointData["COOY"]), parseFloat(pointData["COOX"])];
            const distance = L.GeometryUtil.distance(data.map, data.latlng, latlng) * getMetresPerPixel(data.map);

            if (distance < 300) {
              points.push(pointData);
            }
          });

          if (points.length > 0) {
            unitLayersWithin[x.layer.options.unit.id] = {
              unit: x.layer.options.unit,
              points: points,
            };
          }
        }
      }
    });

    onSetWinterPoupup({ dataPoupup: Object.values(unitLayersWithin).length === 0 ? null : unitLayersWithin, positionPoupup: data.latlng });
  }

  render() {
    const { winterSensorsFilter, unit, winterRouteSmoothFactor, color, winterCompaniesRoutesDataState } = this.props;

    if (winterCompaniesRoutesDataState !== states.READY) return null;

console.log(winterSensorsFilter)

    return (
      <div>
        <Polyline
          key={unit.id}
          pathOptions={{ weight: 2, color: color, renderer: svgRender, unit, smoothFactor: winterRouteSmoothFactor }}
          positions={[unit.dataRoute.route]}
          eventHandlers={{
            click: (e) => {
              const map = e.target._map;
              const radius = getPixelCircleRadius(map);

              const latlng = e.latlng;
              const layers = Object.values(map._layers).filter((x) => {
                return x.options.unit !== undefined;
              });

              const layersWithin = L.GeometryUtil.layersWithin(map, layers, latlng, radius);
              this.setPoupupLayers({ map, radius, latlng, layersWithin });
            },
          }}
        />

        {winterSensorsFilter.viewRouteDump && unit.dataRoute.routeDump.length > 0 ? (
          <Polyline
            key={unit.id + "routeDump"}
            pathOptions={{
              weight: 5,
              opacity: 1,
              color: winterSensorsFilter.dumpColor,
              renderer: svgRender,
              smoothFactor: winterRouteSmoothFactor,
            }}
            positions={[unit.dataRoute.routeDump]}
          >
            <WinterMaintenceSensorRoutePoupup unit={unit} isDump={true} />
          </Polyline>
        ) : null}

        {winterSensorsFilter.viewRouteDump2 && unit.dataRoute.routeDump2.length > 0 ? (
          <Polyline
            key={unit.id + "routeDump2"}
            pathOptions={{
              weight: 5,
              opacity: 1,
              color: winterSensorsFilter.dump2Color,
              renderer: svgRender,
              smoothFactor: winterRouteSmoothFactor,
            }}
            positions={[unit.dataRoute.routeDump2]}
          >
            <WinterMaintenceSensorRoutePoupup unit={unit} isDump2={true} />
          </Polyline>
        ) : null}

        {winterSensorsFilter.viewRouteSand && unit.dataRoute.routeSand.length > 0 ? (
          <Polyline
            key={unit.id + "routeSand"}
            pathOptions={{
              weight: 7,
              opacity: 0.65,
              color: winterSensorsFilter.sandColor,
              renderer: svgRender,
              smoothFactor: winterRouteSmoothFactor,
            }}
            positions={[unit.dataRoute.routeSand]}
          >
            <WinterMaintenceSensorRoutePoupup unit={unit} isSand={true} />
          </Polyline>
        ) : null}
      </div>
    );
  }
}

const svgRender = L.svg({
  tolerance: 5,
  padding: 2,
});

function getMetresPerPixel(map) {
  return (40075016.686 * Math.abs(Math.cos((map.getCenter().lat / 180) * Math.PI))) / Math.pow(2, map.getZoom() + 8);
}

function getPixelCircleRadius(map) {
  const metresPerPixel = getMetresPerPixel(map);
  const raduis = Math.round(30 / metresPerPixel);

  return raduis < 5 ? 5 : raduis;
}

export default withWinterMaintence(React.memo(WinterMaintenceMapUnitRouteLayer));
